const PHOTOS = ['https://datastreet-photos.s3-us-west-1.amazonaws.com/placeholder.png']

export { PHOTOS }
